<template>
<div id="login" style="backgroundImage: url('static/b1.jpg');
                        background-repeat:no-repeat; background-position: center center;
                        background-attachment: fixed; background-size:cover; height:100%; margin-top: -20px">

  <v-container id="login" fluid tag="section">
    <v-layout align-center justify-center>

      <v-flex xs12 sm8 md4 lg4>


        <div class="layout column align-center" style="margin-top:150px;">

          <p />
          <p />
        </div>
        <v-row justify="center">

          <v-slide-y-transition appear>
            <v-card light max-width="100%" width="400" class="px-5 py-3" style="padding: 10px !important; background: rgba(132,192,202, 0.9);">


              <v-card-text class="text-center">
                <img src="/static/logo.png" alt="PowerCFDI" style="width:250px; " />
                <v-text-field color="primary" label="Usuario" @keyup.enter="loguear" prepend-icon="mdi-face" v-model="model.user" :rules="[this.$rules.required]" />

                <v-text-field v-if="user_ok" class="mb-8" color="primary" label="Contraseña" ref="campo_pass" @keyup.enter="loguear" prepend-icon="mdi-lock-outline" v-model="model.pass" :rules="[this.$rules.required]"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" />
                <v-btn text style="text-transform: capitalize;text-align:right;margin-top:-70px;" v-if="user_ok" v-bind:disabled="model.user === ''" color="info" small @click.native="modal=true">
                  Recuperar Contraseña
                </v-btn>
              </v-card-text>
              <v-card-actions class="px-5 py-3">
                <v-row>
                  <v-spacer></v-spacer>
                  <v-btn v-bind:disabled="model.user === ''" color="primary" small @click.native="loguear">
                    Continuar <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>

                </v-row>
              </v-card-actions>
              <v-dialog v-model="modal" max-width="450px">
                <v-card>
                  <v-card-title>
                    Recuperar Contraseña
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form ref="resetform">
                        <v-row>
                          <v-col sm="12" md="12">
                            <v-text-field v-model="model.user" label="Usuario" :rules="[rules.required, rules.email]"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="default" small @click="modal=false">
                      <v-icon small>mdi-cancel</v-icon> Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="user_ok" color="success" small @click="reset()">
                      <v-icon small>mdi-check-circle-outline</v-icon> Enviar correo de recuperación
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card>
          </v-slide-y-transition>

        </v-row>
        </p>
        </p>
        <div class="text-center" style="color:white">
          Versión 2.0 - Desarrollado por <a style="color:white" href="https://power-devel.com">Power-Devel</a> - Software Solutions © 2022
        </div>
        </v-card-actions>
        </base-material-card>
        </v-slide-y-transition>

        </v-row>

      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import moment from "moment";
export default {
  name: 'PagesLogin',

  components: {

  },

  data: () => ({
    tipos_usuario: ['Super', 'Admin', 'User'],
    model: "",
    show1: false,
    tabla: "usuarios",
    user_ok: false,
    data: "",
    modal: false,
    rules: {},
  }),
  created: function() {
    this.model = this.clean_model();
    this.rules = this.$rules;
    this.URL = this.$hostname + "carta_porte/general/";
  },
  methods: {
    clean_model: function() {
      return {
        user: "",
        pass: "",
        nombre: "",
        tipo_usuario: "",
        sesion_activa: false,
        URL: ""
      };
    },
    reset: async function() {
      var self = this;
      if (this.$refs.resetform.validate()) {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        let id_usuario = await this.validaCorreo();
        if (id_usuario !== false) {

          var fi = moment().format('YYYY-MM-DD');
          var ff = moment(fi).add(2, "days").format('YYYY-MM-DD');

          var params = {
            TableName: "solicitud_password",
            Item: {
              uuid: this.$uuid.v4(),
              fecha: fi,
              caducidad: ff,
              estatus: 0, //0-Activa/Pendiente, 1-Ya utilizado
              uuid_usuario: id_usuario,
              correo: self.model.user,
            },
          };
          var self = this;
          self.$axios.post(self.URL + "reset_password/", params).then(res => {
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "Se enviarán instrucciones de recuperación de contraseña a su correo.",
                footer: "",
              });
              self.modal = false;
              self.$root.$dialogLoader.hide();
          }).catch(err => {
              self.$swal({
              type: "error",
              title: "¡Error!",
              text: "Ocurrió un error.",
              footer: "",
            });
            self.modal = false;
            self.$root.$dialogLoader.hide();
          });

        } else {
          self.$swal({
            type: "error",
            title: "¡Error!",
            text: "Correo no válido.",
            footer: "",
          });
          self.modal = false;
          self.$root.$dialogLoader.hide();
        }

      }
    },
    validaCorreo: async function() {
      var self = this;
      return new Promise(function(resolve, reject) {
        var search = {
          "email": self.model.user
        };

        self.$axios.post(self.URL + "validar_correo/", search)
          .then(res => {
            var data = res.data;
            if (data.uuid != "" && data.uuid != undefined) {
              if (data.estatus) {
                self.user_ok = true;
                resolve(data.uuid);
              } else {
                self.user_ok = false;
                resolve(false);
              }
            } else {
              self.user_ok = false;
              resolve(false);
            }
          })
          .catch(err => {
            self.user_ok = false;
            resolve(false);
          })
      });

    },
    loguear: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var password = this.$crypto.SHA256(this.model.pass);

      var self = this;

      var search = {};

      if (!self.user_ok) {
        search = {
          "email": this.model.user
        };
      } else {
        search = {
          "email": this.model.user,
          "password": password
        };
      }
      this.$axios.post(this.URL + "login/", search)
        .then(res => {
          if (res.data === true) {
            if (!self.user_ok) {
              self.user_ok = true;
              setTimeout(function() {
                self.$refs.campo_pass.focus();
              }, 15);
            }
          } else {
            self.data = res.data;
            if (self.data.estatus) {
              // let time_dif = (Date.now() - self.data.ultimo_movimiento) / 60000;

              /*  if (self.data.sesion_activa && time_dif < 10) {
                 self.$swal({
                   type: "error",
                   title: "¡ACCESO DENEGADO!",
                   text: "EL USUARIO TIENE UNA SESIÓN ACTIVA",
                   footer: "",
                 });

                 return;
               } */
              self.inicializa();
            } else {
              self.$swal({
                type: "error",
                title: "¡ACCESO DENEGADO!",
                text: "EL USUARIO SE ENCUENTRA INACTIVO, FAVOR DE COMUNICARCE CON EL ADMINISTRADOR DEL SISTEMA",
                footer: "",
              });
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡ACCESO DENEGADO!",
            text: "USUARIO O CONTRASEÑA INVÁLIDOS, FAVOR DE VERIFICAR E INTENTAR NUEVAMENTE",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });
    },
    carga_empresa(id){


                this.$root.$dialogLoader.show("Espere un momento por favor..");
          var self = this;
          var params = {
            filtros: {
              uuid: id
            }
          };
          this.$axios.post(this.$hostname + "carta_porte/administracion/list_empresas/", params)
            .then(res => {

              if (typeof res.data !== "undefined") {

                self.$local_storage.set(self.$crypto.SHA256("uuid_empresa"), self.$crypto.encrypted(res.data[0].uuid));
                self.$local_storage.set(self.$crypto.SHA256("nombre_empresa"), self.$crypto.encrypted(res.data[0].nombre));
              }
            })
            .catch(err => {
              this.$swal({
                type: "error",
                title: "Error",
                text: "Ocurrió un error al obtener el registro.",
                footer: "",
              });
              console.log(err);
            }).then(() => {
              self.$root.$dialogLoader.hide();
            });
    },
    activa_sesion: async function() {
      this.data.sesion_activa = true;
      this.data.ultimo_movimiento = Date.now();

      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;
      var params = {
        "uuid": this.data.uuid,
        "sesion_activa": this.data.sesion_activa,
        "ultimo_movimiento": this.data.ultimo_movimiento
      };

      await this.$axios.post(this.$hostname + "carta_porte/administracion/update_usuario/", params)
        .then(res => {})
        .catch(err => {
          self.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al activar la sesión.",
            footer: "",
          });
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });
    },
    inicializa: async function() {

      let self = this;
      await self.activa_sesion();
      self.$local_storage.set(self.$crypto.SHA256("uuid_usuario"), self.$crypto.encrypted(self.data.uuid));
      self.$user.set({
        uuid_usuario: self.$crypto.encrypted(self.data.uuid),
        role:1
      });
      self.$store.state.uuid_usuario = self.$crypto.encrypted(self.data.uuid);
      self.$local_storage.set(self.$crypto.SHA256("tipo_usuario"), self.$crypto.encrypted(self.data.tipo.toString()));
      self.$local_storage.set(self.$crypto.SHA256("nombre_usuario"), self.$crypto.encrypted(self.data.nombre));
      self.$local_storage.set(self.$crypto.SHA256("uuid_empresa"), self.$crypto.encrypted(self.data.uuid_empresa));

      self.$local_storage.set(self.$crypto.SHA256('factura.nueva'), self.$crypto.encrypted('1'));
      self.$local_storage.set(self.$crypto.SHA256('factura.cancelar'), self.$crypto.encrypted('1'));
      self.$local_storage.set(self.$crypto.SHA256('factura.pagos'), self.$crypto.encrypted('1'));
      self.$local_storage.set(self.$crypto.SHA256('factura.notas'), self.$crypto.encrypted('1'));
      self.$local_storage.set(self.$crypto.SHA256('factura.borradores'), self.$crypto.encrypted('1'));
      self.$local_storage.set(self.$crypto.SHA256('factura.consulta'), self.$crypto.encrypted('1'));
      self.$local_storage.set(self.$crypto.SHA256('factura.reportes'), self.$crypto.encrypted('1'));
      self.$local_storage.set(self.$crypto.SHA256('catalogos.administrar'), self.$crypto.encrypted('1'));
      self.$local_storage.set(self.$crypto.SHA256('configuracion.administrar'), self.$crypto.encrypted('1'));

      if (self.data.tipo == 3) {}
      self.$store.state.instancia = self.$crypto.encrypted(self.data.uuid_empresa);
      if (self.data.permisos.length > 0) {
        self.$local_storage.set(self.$crypto.SHA256('factura.nueva'), self.$crypto.encrypted('0'));
        self.$local_storage.set(self.$crypto.SHA256('factura.cancelar'), self.$crypto.encrypted('0'));
        self.$local_storage.set(self.$crypto.SHA256('factura.pagos'), self.$crypto.encrypted('0'));
        self.$local_storage.set(self.$crypto.SHA256('factura.notas'), self.$crypto.encrypted('0'));
        self.$local_storage.set(self.$crypto.SHA256('factura.borradores'), self.$crypto.encrypted('0'));
        self.$local_storage.set(self.$crypto.SHA256('factura.consulta'), self.$crypto.encrypted('0'));
        self.$local_storage.set(self.$crypto.SHA256('factura.reportes'), self.$crypto.encrypted('0'));
        self.$local_storage.set(self.$crypto.SHA256('catalogos.administrar'), self.$crypto.encrypted('0'));
        self.$local_storage.set(self.$crypto.SHA256('configuracion.administrar'), self.$crypto.encrypted('0'));

        self.data.permisos.forEach(element => {
          if (element.uuid == 'factura.nueva') self.$local_storage.set(self.$crypto.SHA256('factura.nueva'), self.$crypto.encrypted('1'));
          if (element.uuid == 'factura.pagos') self.$local_storage.set(self.$crypto.SHA256('factura.pagos'), self.$crypto.encrypted('1'));
          if (element.uuid == 'factura.cancelar') self.$local_storage.set(self.$crypto.SHA256('factura.cancelar'), self.$crypto.encrypted('1'));
          if (element.uuid == 'factura.notas') self.$local_storage.set(self.$crypto.SHA256('factura.notas'), self.$crypto.encrypted('1'));
          if (element.uuid  == 'factura.borradores') self.$local_storage.set(self.$crypto.SHA256('factura.borradores'), self.$crypto.encrypted('1'));
          if (element.uuid  == 'factura.consulta') self.$local_storage.set(self.$crypto.SHA256('factura.consulta'), self.$crypto.encrypted('1'));
          if (element.uuid  == 'factura.reportes') self.$local_storage.set(self.$crypto.SHA256('factura.reportes'), self.$crypto.encrypted('1'));
          if (element.uuid  == 'catalogos.administrar') self.$local_storage.set(self.$crypto.SHA256('catalogos.administrar'), self.$crypto.encrypted('1'));
          if (element.uuid  == 'configuracion.administrar') self.$local_storage.set(self.$crypto.SHA256('configuracion.administrar'), self.$crypto.encrypted('1'));

        });

      }

      if (self.$local_storage.get(self.$crypto.SHA256("uuid_empresa")) != null && self.$local_storage.get(self.$crypto.SHA256("uuid_empresa")) != "") {

        await self.carga_empresa(self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("uuid_empresa"))));
        var saldo = await self.$funciones.get_saldo(self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("uuid_empresa"))));
        self.$local_storage.set("saldo", saldo);
        self.$store.state.instancia += saldo;
      } else {
        self.$local_storage.set("saldo", 0);
        self.$store.state.instancia += 0;
      }

      self.$router.replace("/home");
    },
  },
}
</script>
